import { BookingApi } from 'services/api/booking';
import { Router } from 'utils/with-i18next';

export default function isUserAuthorize(user) {
  if (!user) {
    return;
  }

  if (user?.status) {
    return false;
  }

  if (user?.userType === 'landlord') {
    return true;
  }

  //If user is a renter, check to see if they have any bookings that are either paid, approved, or documents-uploaded.
  //If there are any, redirect them to the first one. Otherwise, redirect them to https://www.realsage.com/properties
  if (user?.userType === 'renter') {
    BookingApi.fetchBookings('tenant')
      .then(res => {
        if (Array.isArray(res.data) && res.data.length > 0) {
          const userBooking = res.data.filter(
            item => item.status === 'paid' || item.status === 'approved' || item.status === 'documents-uploaded'
          );
          if (userBooking.length > 0) {
            Router.push(`/my-bookings/${userBooking[0].id}`);
          } else {
            Router.push('https://www.realsage.com/properties');
          }
        } else {
          Router.push('https://www.realsage.com/properties');
        }
      })
      .catch(err => console.log(err));
  }

  return false;
}
